import React, { useEffect, useState, useRef, Fragment } from "react"
import { Modal } from "react-bootstrap"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { HiOutlineExclamationTriangle } from "react-icons/hi2"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { moment, thousandSeparator } from "utils"
import { topupPaymentServiceOwner } from "services"
import PaymentGatewaySelector from "./PaymentGatewaySelector"
import classes from "./SystemDeactivationWarningModal.module.scss"

const SystemDeactivationWarningModal = () => {
  const wallet = useSelector(state => state.wallet)

  const [t] = useTranslation()

  const { isDeactivationWarningSet, deactivationWarningDate } =
    useSelector(state =>
      state.contractDeactivationStatus
    )

  const [sending, setSending] = useState(false)
  const [paymentGateway, setPaymentGateway] = useState("haghighi_a2a")
  const [showDeactivationWarningModal, setShowDeactivationWarningModal] = useState(false)

  const unmount = useRef(false)

  const handleTopup = async () => {
    setSending(true)

    const minTopup = 10000

    const debt =
      Math.max(
        Math.abs(
          Math.round((wallet.balance / 1000)) * 1000
        ),
        minTopup
      )

    try {
      const { gatewayUrl } =
        await topupPaymentServiceOwner({
          type: paymentGateway,
          amount: debt
        })

      window.location.href = gatewayUrl
    } catch (err) {
      console.log(err)

      if (unmount.current) return

      setSending(false)

      toast.error(t("عملیات_انجام_نشد"))
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  if (!isDeactivationWarningSet) return null

  const currentMoment = moment()

  const expirationDate =
    moment(deactivationWarningDate)

  expirationDate.add(3, "days")

  const daysToExpire =
    expirationDate.diff(currentMoment, "days")

  return (
    <Fragment>
      <button
        className={classes["float-button"]}
        onClick={() => setShowDeactivationWarningModal(true)}
      >
        <HiOutlineExclamationTriangle
          size={30}
        />
      </button>

      <Modal
        show={showDeactivationWarningModal}
        onHide={() => setShowDeactivationWarningModal(false)}
        centered
      >
        <div className={classes["container"]}>
          <div className={classes["title"]}>
            بدهی سرویس شما از حد مجاز بیشتر شده است!
          </div>

          <div className={classes["subtitle"]}>
            مهلت پرداخت بدهی <b><u>{daysToExpire}</u></b> روز دیگر می باشد.
            <br />
            پس از انقضای این مدت، دسترسی به امکانات سامانه محدود خواهد شد.
            <br />
            لطفا جهت پرداخت اقدام نمایید.
          </div>

          {
            wallet &&
            <Fragment>
              <div className={classes["debt"]}>
                بدهی شما:{" "}
                <b>{thousandSeparator(Math.abs(wallet.balance))}</b>
              </div>
            </Fragment>
          }

          <PaymentGatewaySelector
            value={paymentGateway}
            disabled={sending}
            onChange={setPaymentGateway}
          />

          <div className={classes["footer"]}>
            <Button
              color="danger"
              disabled={sending}
              onClick={() => setShowDeactivationWarningModal(false)}
            >
              بستن
            </Button>

            {
              wallet &&
              <Button
                className={classes["button"]}
                color="success"
                loading={sending}
                onClick={handleTopup}
              >
                پرداخت
              </Button>
            }
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default SystemDeactivationWarningModal
